import styled from "@emotion/styled";
import {
  CheckCircleIcon,
  ExclamationCircleIcon,
} from "@heroicons/react/20/solid";
import * as React from "react";

import GhostButton from "./button/GhostButton";
import { chooseThemeVariant } from "./ThemeContext";

const Icon = styled.div`
  width: 16px;
  height: 16px;
`;

type Status = "error" | "success";

const StyledButton = styled(GhostButton)<{ status: Status }>`
  color: ${(props) =>
    chooseThemeVariant({
      translucent: { error: "#EB5D44", success: "#73FCC2" }[props.status],
      default: { error: "#EB5D44", success: "#46CD92" }[props.status],
    })(props)};
`;

const statusIcons: Record<
  Status,
  React.ComponentType<{ className?: string }>
> = {
  error: ExclamationCircleIcon,
  success: CheckCircleIcon,
};

interface StatusMessageProps extends React.ComponentProps<typeof GhostButton> {
  status: Status;
}

const StatusMessage = ({
  status,
  children,
  ...buttonProps
}: StatusMessageProps) => {
  return (
    <StyledButton disabled={true} status={status} {...buttonProps}>
      <Icon as={statusIcons[status]} />

      {children}
    </StyledButton>
  );
};

export default StatusMessage;
